import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
    product: [],
    products: [],
    product_types: [],
    subscription: [],
    current_subscription: [],
    other_subscription: [],
    previous_item_subscriptions: [],
    previous_any_item_subscriptions: [],
    subscriptions: [],
    chosen_item: '',
    item_transaction_history: [],
    receipt_item_info: {},
    receipt_info: [],
    receipt_status: [],
    active_free_month: [],
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
